import { useState } from "react";
import { useSelector } from "react-redux";
import { GameCase } from "app/types";
import { RootState } from "app/store";
import I18n from "common/i18n";
import Constants from "common/constant";
import { usePlaySound } from "common/utils";
import { GameMiniCaseManager } from "common/elements";
import { GameCaseStock } from "../GameCaseStock";

export const ProfileGameCaseTab = () => {
  const play = usePlaySound();
  const config = useSelector((state: RootState) => state.config.userConfig);
  const [gameCaseModalOpen, setGameCaseModalOpen] = useState(false);
  const [selectedGameCase, setSelectedGameCase] = useState<GameCase>(config.game_case);
  const DisplayedGameCaseIcon = GameMiniCaseManager[config.game_case];

  const handleOpenGameCase = () => {
    play();
    setSelectedGameCase(config.game_case);
    setGameCaseModalOpen(true);
  };

  const handleCloseGameCase = () => {
    play();
    setGameCaseModalOpen(false);
  };

  return (
    <>
      <GameCaseStock
        visible={gameCaseModalOpen}
        gameCase={selectedGameCase}
        selectGameCase={setSelectedGameCase}
        close={handleCloseGameCase}
      />

      <div className="flex-col-el flex-center w-full h-full p-3 gap-6">
        <div className="flex-col-el flex-center w-full h-full bg-beige-20 rounded-xl gap-6">
          <div className="flex-row-center w-[706px] h-[372px]">
            <img
              alt="*"
              src={`${Constants.assetHost}/assets/images/${DisplayedGameCaseIcon}`}
              className="w-full h-full"
            />
          </div>
          <div className="flex-row-el flex-center upsilon">
            <button
              onClick={handleOpenGameCase}
              className="btn btn-primary type-inherit-font !py-1 !px-3"
            >
              <div className="flex-row-center gap-1">
                <span className="material-symbols-outlined type-title text-white">edit_note</span>
                <p className="type-text type-body text-white">
                  {I18n.t("MSG_USER_PROFILE_CASE_BTN")}
                </p>
              </div>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
